// REACT
import { useContext, useState } from "react";

// CONTEXT
import { maincontext } from "../context/maincontext";

// COMPONENTS
import ToolHeader from "../components/common/ToolHeader";
import UnresolvedConflicts from "../components/conflict/UnresolvedConflicts";
import ResolvedConflicts from "../components/conflict/ResolvedConflicts";

// ASSETS
import languagePack from "../assets/languages/languagePack";
import Dropdown from "react-bootstrap/Dropdown";
import { FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";

export default function ConflictResolver() {
    const { language } = useContext(maincontext);
    const [mode, setMode] = useState("unresolved");

    const modeOptions = [
        { mode: "unresolved", title: languagePack[language]?.conflictResolver.unresolved },
        { mode: "resolved", title: languagePack[language]?.conflictResolver.resolved },
    ];

    const selectedModeTitle = modeOptions.find(opt => opt.mode === mode)?.title || "";

    return (
        <>
            <ToolHeader
                toolHeader={languagePack[language].conflictResolver.title}
                icon={"conflicts"}
            />

            <Dropdown className="tool-switcher custom-tool-dropdown">
                <Dropdown.Toggle
                    variant="light"
                    id="conflict-mode-dropdown"
                    className="d-flex align-items-center gap-2 custom-dropdown-toggle "
                >
                    {mode === 'unresolved' ? (
                        <FaExclamationTriangle className="text-danger switcher-icon" />
                    ) : mode === 'resolved' ? (
                        <FaCheckCircle className="text-success switcher-icon" />
                    ) : null}
                    {selectedModeTitle}
                </Dropdown.Toggle>

                <Dropdown.Menu className="custom-dropdown-menu">
                    {modeOptions.map(option => (
                        <Dropdown.Item
                            key={option.mode}
                            onClick={() => setMode(option.mode)}
                            active={option.mode === mode}
                            className="d-flex align-items-center gap-2 custom-dropdown-item"
                        >
                            {option.mode === 'unresolved' ? (
                                <FaExclamationTriangle className="text-danger switcher-icon" />
                            ) : option.mode === 'resolved' ? (
                                <FaCheckCircle className="text-success switcher-icon" />
                            ) : null}
                            {option.title}
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
            {mode === "unresolved" ? (
                <UnresolvedConflicts />
            ) : mode === "resolved" ? (
                <ResolvedConflicts isResolved={true} />
            ) : (
                <></>
            )}
        </>
    );
}
